/**
 * InningState Component
 */

import React, { FC } from 'react';
import { withTheme } from 'styled-components';
import { InningStateProps } from './inningState.types';
import {
  StyledBasepathsWrapper,
  StyledCountWrapper,
  StyledInningWrapper,
  StyledOutsWrapper,
  StyledInningHalf,
  StyledOutsText
} from './inningState.style';
import Outs from '../Outs/outs';
import Basepaths from '../Basepaths/basepaths';

const constrainCount = (num: number, upperbound: number, lowerbound: number): number => {
  return Math.min(Math.max(num, lowerbound), upperbound);
}

const InningState: FC<InningStateProps> = ({
  strikes = 0,
  balls = 0,
  outCount = 0,
  first = false,
  second = false,
  third = false,
  basesAltText,
  outsAltText,
  basepathsWidth = 24,
  outsWidth = 25,
  theme = {},
  showCount = true,
  showOutsText = false,
  inningHalfText,
  className,
  filledColor,
  strokeColor,
  emptyColor,
  outsInactiveColor,
  outsActiveColor
}: InningStateProps) => {

  const { dark = false } = theme;

  const maxWidth: number = Math.max(basepathsWidth, outsWidth)

  const strikeCount: number = constrainCount(strikes, 3, 0);
  const ballCount: number = constrainCount(balls, 4, 0);

  return (
    <StyledInningWrapper width={ maxWidth } className={ className }>
      { inningHalfText && (
        <StyledInningHalf dark={ dark }>
          { inningHalfText }
        </StyledInningHalf>)
      }
      <StyledBasepathsWrapper width={ maxWidth }>
        <Basepaths
          first={ first }
          second={ second }
          third={ third }
          altText={ basesAltText }
          width={ basepathsWidth }
          filledColor={filledColor}
          strokeColor={strokeColor}
          emptyColor={emptyColor}
        />
      </StyledBasepathsWrapper>

      { !showOutsText &&  (
        <StyledOutsWrapper width={ maxWidth }>
          <Outs
            outCount={ outCount }
            altText={ outsAltText }
            width={ outsWidth }
            outsInactiveColor={ outsInactiveColor }
            outsActiveColor={ outsActiveColor }
          />
        </StyledOutsWrapper>)
      }

      { showCount ? (
        <StyledCountWrapper dark={ dark }>
          { `${ballCount} - ${strikeCount}` }
          { showOutsText && (
            <StyledOutsText>, {outCount} Out</StyledOutsText>)
          }
        </StyledCountWrapper>)
        : null
      }
    </StyledInningWrapper>
  );
};

export default withTheme(InningState);
